/* ============
 * Vuex Store
 * ============
 *
 * The store of the application.
 *
 * http://vuex.vuejs.org/en/index.html
 */
import Vuex from 'vuex';

import { ConstructionStoreState } from './ConstructionTypes';
import { ConstructionStoreModule } from './ConstructionStore';
import { isDevelopment } from '../../config/app.config';

/**
 * Define your Store here
 */
export interface Store {
    construction: ConstructionStoreState;
}

export const store = new Vuex.Store<Store>({
    strict: isDevelopment(),
    modules: {
        construction: ConstructionStoreModule,
    },
});
